import { render, staticRenderFns } from "./VerifierAdmonition.vue?vue&type=template&id=8cdec898&"
import script from "./VerifierAdmonition.vue?vue&type=script&lang=js&"
export * from "./VerifierAdmonition.vue?vue&type=script&lang=js&"
import style0 from "./VerifierAdmonition.vue?vue&type=style&index=0&id=8cdec898&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports